// constants.js
export const AIRTABLE_BASE_ID = process.env.REACT_APP_AIRTABLE_BASE_ID;
export const AIRTABLE_API_KEY = process.env.REACT_APP_AIRTABLE_API_KEY;
export const IMGBB_API_KEY = process.env.REACT_APP_IMGBB_API_KEY;

export const TABLE_SHEET1 = "Sheet1";
export const TABLE_TECHNICIAN = "technician";

// ✅ Only one table per URL
export const AIRTABLE_URL = `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${TABLE_SHEET1}`;
export const AIRTABLE_URL_TECHNICIAN = `https://api.airtable.com/v0/${AIRTABLE_BASE_ID}/${TABLE_TECHNICIAN}`;

export const AIRTABLE_HEADERS = {
  Authorization: `Bearer ${AIRTABLE_API_KEY}`,
  "Content-Type": "application/json",
};

export const SHEET_URL = AIRTABLE_URL;